<template>
    <app-content>
        <form action="#">
            <div class="inner">
                <p class="buttons">
                    <app-button-delete @click="deleteItem" v-if="!newItem"/>
                </p>
                <app-content-title v-if="!newItem && !pending"
                                   :title="item.name"/>
                <app-content-title v-if="newItem" :title="translations.newCurrency"/>
            </div>
            <div :title="translations.information">
                <app-settings @submit="onFormSubmit" :disabled="pending">
                    <app-settings-content>
                        <app-settings-desc :title="translations.basicInfo">
                            <p>
                                <translate>Založeno</translate>
                                :<br/>
                                <span v-html="formatDateAdvanced(item._created)"/>
                            </p>
                        </app-settings-desc>

                        <app-settings-options>
                            <app-settings-col class="field_left">
                                <app-input
                                    :label="translations.name"
                                    required
                                    :error="errors.items.find(el => el.field === 'name')"
                                    v-model="formItem.name"
                                    name="name"

                                />
                            </app-settings-col>
                            <app-settings-col class="field_right">
                                <app-input
                                    :label="translations.symbol"
                                    required
                                    :error="errors.items.find(el => el.field === 'symbol')"
                                    v-model="formItem.symbol"
                                    name="symbol"

                                />
                            </app-settings-col>
                            <app-settings-col class="field_left">
                                <app-input
                                        :label="translations.isoCode"
                                        required
                                        :error="errors.items.find(el => el.field === 'isoCode')"
                                        v-model="formItem.isoCode"
                                        name="isoCode"

                                />
                            </app-settings-col>
                            <app-settings-col class="field_right">
                                <app-input
                                    :label="translations.format"
                                    required
                                    :error="errors.items.find(el => el.field === 'format')"
                                    v-model="formItem.format"
                                    name="format"

                                />
                            </app-settings-col>
                        </app-settings-options>
                    </app-settings-content>

                    <app-settings-buttons :navLinkTitle="translations.list" :nav-link-to="{ name: 'vodCurrencies' }">
                        <app-content-save-button :disabled="pending" @click="disallowBack"/>
                    </app-settings-buttons>
                </app-settings>
            </div>
        </form>
    </app-content>
</template>

<script>
import getItemDetailMixin from 'mixins/getItemDetailMixin'
import appTitleMixin from 'mixins/appTitleMixin'
import formatDateMixin from 'mixins/formatDateMixin'
import { getCommonFormSubmit } from 'utils/form'

const itemDetailMixin = getItemDetailMixin({
  apiMethodsSuffix: 'Currency',
  parentRouteName: 'vodCurrencies',
  storeModuleName: 'currencies',
  storeItemName: 'currency'
})

export default {
  name: 'currency-item',
  mixins: [formatDateMixin, itemDetailMixin, appTitleMixin()],
  methods: {
    async onFormSubmit(e) {
      this.errors.clear()

      this.formErrors = await this.runValidation()
      if (this.formErrors.items.length > 0) {
        this.appShowErrors(this.formErrors.items.map(v => v.msg))
        return
      }

      const commonFormSubmit = getCommonFormSubmit('Currency')
      const response = await
      commonFormSubmit(this, e).catch(err => err.response)

      this.handleResponseIfError(response)

      if (!this.backAllowed && response.status === 201) {
        this.goToDetail(response.data.data._id)
      }
    },
    async runValidation() {
      await this.errors.clear()
      await this.$validator.validateAll()
      return this.errors
    }
  },
  computed: {
    translations() {
      return {
        newCurrency: this.$gettext('Nová měna'),
        name: this.$gettext('Název'),
        symbol: this.$gettext('Symbol'),
        basicInfo: this.$gettext('Základní údaje'),
        isoCode: this.$gettext('ISO 4217'),
        list: this.$gettext('Seznam'),
        information: this.$gettext('Informace'),
        format: this.$gettext('Formát'),
      }
    },
    currentTitle() {
      return [
        { name: this.$gettext('Měny'), link: { name: 'vodCurrencies' } },
          this.item.name || this.translations.newCurrency
      ]
    },
  }
}
</script>
